import {
  createContext,
  useContext,
  useEffect,
  useState,
  type ReactNode,
} from 'react';
import { useMediaQuery } from '../hooks/useMediaQuery';

interface PersistentRouteProps {
  active: boolean;
  children: ReactNode;
}

const PersistentRouteActiveContext = createContext(true);

export const usePersistentRouteActive = () => useContext(PersistentRouteActiveContext);

/**
 * Mounts its content on first activation and keeps the same UI subtree alive.
 * Camera sessions themselves are owned by the global StreamManager and are
 * therefore independent from this route subtree.
 */
export function PersistentRoute({ active, children }: PersistentRouteProps) {
  const [activated, setActivated] = useState(active);
  const persistInactive = useMediaQuery('(min-width: 1024px)', true);

  useEffect(() => {
    if (active) setActivated(true);
  }, [active]);

  if (!active && (!activated || !persistInactive)) return null;

  return (
    <PersistentRouteActiveContext.Provider value={active}>
      <div
        className={`persistent-route ${active ? '' : 'persistent-route--hidden'}`}
        aria-hidden={!active}
        inert={!active}
      >
        {children}
      </div>
    </PersistentRouteActiveContext.Provider>
  );
}
